import React from "react";
import UrgencyCard from "../urgencyCard";
import Text from "../text";
import {
  Container,
  BlocContainer,
  UrgencyCardContainer,
} from "./styled-components";
import { map } from "lodash";

const UrgencyBloc = () => {
  const urgencies = [
    {
      title: "Numéro d’aide aux victimes",
      phoneNumber: "116 006",
      href: "http://www.justice.gouv.fr/aide-aux-victimes-10044/116006-12126/",
    },
    {
      title: "Harcèlement à l'école",
      phoneNumber: "3020",
      href: "https://www.education.gouv.fr/non-au-harcelement/lutte-contre-le-harcelement-l-ecole-289530",
    },
    {
      title: "Violences conjugales",
      phoneNumber: "3919",
      href: "https://lannuaire.service-public.fr/centres-contact/R17892",
    },
    {
      title: "Enfants maltraités ou en danger",
      phoneNumber: "119",
      href: "https://www.allo119.gouv.fr/",
    },
    {
      title: "Maltraitances des personnes âgées et des personnes handicapées",
      phoneNumber: "3977",
      href: "https://3977.fr/",
    },
  ];

  return (
    <BlocContainer>
      <Text size="24px" lineHeight="32px" align="center" weight={700}>
        Les numéros à contacter en cas d’urgence{" "}
      </Text>
      <Container id="urgecyBloc">
        {map(urgencies, ({ title, phoneNumber, href }, index) => (
          <UrgencyCardContainer
            isLast={index === urgencies.length - 1}
            key={index}
          >
            <UrgencyCard title={title} phoneNumber={phoneNumber} href={href} />
          </UrgencyCardContainer>
        ))}
      </Container>
    </BlocContainer>
  );
};

export default UrgencyBloc;
